export default {
	styleOverrides: {
		root: ({ theme }) => ({
			backgroundColor: 'transparent',
			padding: '4px 8px',
			fontSize: theme.typography.caption.fontSize,
			fontWeight: 500,
			lineHeight: theme.typography.caption.lineHeight,
		}),
	},
}
